<!-- ----------------------------------------------------------------------- -->
<!--                               Health Card                               -->
<!-- ----------------------------------------------------------------------- -->
<form
    [formGroup]="cardForm"
    nz-form
    nzLayout="vertical"
    nzNoColon="true"
    class="card-form"
>
    <div
        class="health-card-container Ontario"
        [ngClass]="disabled ? 'disabled' : ''"
    >
        <img
            class="bg-logo"
            src="https://booking.portals.care/assets/libs/ui/ontario-hc/ontario-logo-img.png"
        />

        <!-- ----------------------------- card header ----------------------------- -->

        <div class="hc-header">
            <!-- ontario -->
            <ng-container *ngIf="true">
                <img
                    src="https://booking.portals.care/assets/libs/ui/ontario-hc/ontario-logo.png" />
                <h4>Health Card</h4>
            </ng-container>
            <!-- ontario red (disabled) -->
            <ng-container *ngIf="false">
                <img
                    src="https://booking.portals.care/assets/libs/ui/ontario-hc/ontario-logo-v.png" />
                <h4>Health . Santé</h4>
            </ng-container>
            <!-- non ontario (disabled) -->
            <ng-container *ngIf="false">
                <h4>Health Card</h4>
            </ng-container>
        </div>

        <!-- ------------------------------ card body ------------------------------ -->

        <div class="hc-body">

            <div class="input-row card-number-row">
                <nz-form-item class="hcNum">
                    <nz-form-control
                        nzHasFeedback
                        [nzErrorTip]="hcNumErrorTpl"
                    >
                        <input
                            nz-input
                            formControlName="hcNum"
                            placeholder="Number i.e.1234567890"
                        />
                    </nz-form-control>
                </nz-form-item>
                <ng-template
                    #hcNumErrorTpl
                    let-control
                >
                    <div *ngIf="control.hasError('pattern')">
                        * Only numbers are allowed
                    </div>
                    <div *ngIf="control.hasError('minlength')">
                        * Health card is exactly 10 numbers
                    </div>
                    <div *ngIf="control.hasError('maxlength')">
                        * Health card numbers is exactly 10 numbers
                    </div>
                    <div *ngIf="control.hasError('required')">
                        * This field is required
                    </div>
                </ng-template>


                <nz-form-item class="hcVer">
                    <nz-form-control
                        nzHasFeedback
                        [nzErrorTip]="'Invalid'"
                    >
                        <input
                            nz-input
                            formControlName="hcVer"
                            placeholder="XY"
                            pattern="[A-Za-z]{2}"
                            type="text"
                            name="hcVer"
                        />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div class="input-row card-dates-row">
                <nz-form-item class="hcEff">
                    <nz-form-label nzRequired>
                        Issue Date
                    </nz-form-label>
                    <nz-form-control
                        nzHasFeedback
                        [nzErrorTip]="dateErrorTpl"
                    >
                        <date-input
                            format="yyyy-MM-dd"
                            formControlName="hcEff"
                        >
                        </date-input>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item class="hcExp">
                    <nz-form-label nzRequired>
                        Expiry Date
                    </nz-form-label>

                    <nz-form-control
                        nzHasFeedback
                        [nzErrorTip]="dateErrorTpl"
                    >
                        <date-input
                            format="yyyy-MM-dd"
                            formControlName="hcExp"
                        >
                        </date-input>
                    </nz-form-control>
                </nz-form-item>

                <ng-template
                    #dateErrorTpl
                    let-control
                >
                    <ng-container *ngIf="control.hasError('required')">
                        - Required
                    </ng-container>
                    <ng-container *ngIf="control.hasError('invalidDate')">
                        - Invalid date
                    </ng-container>
                </ng-template>
            </div>
        </div>
        <!-- /card body -->
    </div>
</form>